import { render } from "./form-recaptcha.vue?vue&type=template&id=5b031f9c&scoped=true"
import script from "./form-recaptcha.js?vue&type=script&lang=js&external"
export * from "./form-recaptcha.js?vue&type=script&lang=js&external"

import "./form-recaptcha.scss?vue&type=style&index=0&id=5b031f9c&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b031f9c"]])

export default __exports__